module.exports = __webpack_public_path__ + "img/8c68a4bf10e1ce38c3add9689b0883b6.png";